const studentgroups = {
	title: "Elevgrupper",
	new_studentgroup: "Ny gruppe",
	edit_studentgroup: "Rediger: {name}",
	view_studentgroup: "Vis: {name}",
	list_title: "Elevgrupper",
	list_subtitle: "Endre elevgrupper",
	create_title: "Ny elevgruppe",
	update_title: "Endre elevgruppe",
	id: "ID",
	name: "Gruppenavn",
	code: "Programkode",
	groupcode: "Gruppekode",
	status: "Status",
	created_by: "Opprettet",
	educationprogram_id: "Utdanningsområde",
	qty: "Antall",
	enrol_tooltip: "Meld valgte elev(er) på kurs",
	new_tooltip: "Opprett ny elev",
	select_tooltip: "Velg elev(er) fra elevlista",
	remove_tooltip: "Fjern elev(er) fra gruppa",
};
export default studentgroups;